'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themeProvider = require('@spp/theme-provider');

var _InlineVideo = require('./InlineVideo');

var _InlineVideo2 = _interopRequireDefault(_InlineVideo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _themeProvider.themer)('@spp/inline-video')(_InlineVideo2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/inline-video/lib/cjs/index.js
 ** module id = 541
 ** module chunks = 1
 **/